import { Button, Flex } from '@chakra-ui/react'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { HeadingPages } from '../../components/HeadingPages'
import InputFloating from '../../components/InputFloating'
import * as yup from 'yup'
import Axios from 'axios'
import { format } from 'date-fns'

const schema = yup.object().shape({
  data_inicial: yup.string().required('Campo obrigatório'),
  data_final: yup.string().required('Campo obrigatório'),
})

export function RelatorioNFG() {
  const {
    register,
    handleSubmit,
    formState: { isSubmitting, errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  })

  async function getRelatorioNFG(data) {
    const response = await Axios.get(
      `${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-parceiro-fonseca-pdf/${data.data_inicial}/${data.data_final}`,
      {
        responseType: 'blob',
      }
    )

    const dateFormatInitial = format(new Date(data.data_final), 'dd-MM-yyyy')
    const dateFormatFinal = format(new Date(data.data_final), 'dd-MM-yyyy')

    const url = window.URL.createObjectURL(new Blob([response.data]))

    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `relatorio ${dateFormatInitial + ' à ' + dateFormatFinal}.pdf`)

    document.body.appendChild(link)
    link.click()

    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)

    reset()
  }

  return (
    <>
      <HeadingPages name="Relatório NFG" />

      <Flex width="100%">
        <Flex
          margin="auto"
          width="100%"
          maxWidth="1200px"
          padding="1rem"
          gap={2}
          alignItems="center"
          justifyContent="center"
          as="form"
          onSubmit={handleSubmit(getRelatorioNFG)}
        >
          <Flex maxW="700px" gap={2} flexDir="column" mt="2rem">
            <Flex maxW="700px" gap={2}>
              <InputFloating type="date" label="Data Inicial" {...register('data_inicial')} error={errors.data_inicial} />
              <InputFloating type="date" label="Data Final" {...register('data_final')} error={errors.data_final} />
            </Flex>
            <Button colorScheme="blue" variant="solid" type="submit" isLoading={isSubmitting}>
              Gerar PDF
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </>
  )
}
